import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT

export const getWriteoffList = (params) => {
  return axios.post(root + '/voucher/accountwriteoff/list', qs.stringify(params))
}

export const saveWriteoff = (params) => {
  return axios.post(root + '/voucher/accountwriteoff/save', qs.stringify(params))
}

export const getDetail = (params) => {
  return axios.post(root + '/voucher/accountwriteoff/detail', qs.stringify(params))
}

export const deleteWriteoff = (params) => {
  return axios.post(root + '/voucher/accountwriteoff/remove', qs.stringify(params))
}

export const exportWriteoff = (params) => {
  return axios.post(root + '/voucher/accountwriteoff/export', qs.stringify(params))
}

export const importWriteoff = (params) => {
  return axios.post(root + '/voucher/accountwriteoff/import', qs.stringify(params))
}

export const listWriteoffByVoucher = (params) => {
  return axios.post(root + '/voucher/accountwriteoff/listByVoucher', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/voucher/accountwriteoff.js